import { createSlice } from '@reduxjs/toolkit';
import type { AppState } from '../AppStore';
import { getRoles } from './RoleSlice';
import { getApiKeys } from './ApiKeySlice';
import { getApplications } from './ApplicationSlice';
import { getUsers } from './UserSlice';
import { updateTableData } from '../../store/utilities/SliceDataHelper';

import type { IAdministrationState } from '../../../types/IComponentTypes';

const initialState: IAdministrationState = {
  users: {
    data: {},
    totalCount: 0,
    currentPage: 0,
    searchKey: '',
    recordsPerPage: 0,
  },
  roles: {
    data: {},
    totalCount: 0,
    currentPage: 0,
    searchKey: '',
    recordsPerPage: 0,
  },
  apikeys: {
    data: {},
    totalCount: 0,
    currentPage: 0,
    searchKey: '',
    recordsPerPage: 0,
  },
  applications: {
    data: {},
    totalCount: 0,
    currentPage: 0,
    searchKey: '',
    recordsPerPage: 0,
  },
};

const administrationSlice = createSlice({
  name: 'administration',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUsers.fulfilled, (state, action) => {
        if (!('error' in action.payload)) {
          return updateTableData(state.users, action.payload);
        }
        return state;
      })
      .addCase(getRoles.fulfilled, (state, action) => {
        if (!('error' in action.payload)) {
          return updateTableData(state.roles, action.payload);
        }
        return state;
      })
      .addCase(getApiKeys.fulfilled, (state, action) => {
        if (
          !('error' in action.payload) &&
          'skipUpdate' in action.payload &&
          !action.payload.skipUpdate
        ) {
          return updateTableData(state.apikeys, action.payload);
        }
        return state;
      })
      .addCase(getApplications.fulfilled, (state, action) => {
        if (!('error' in action.payload)) {
          return updateTableData(state.applications, action.payload);
        }
        return state;
      });
  },
});

export const administration = (state: AppState) => state.administration;

export default administrationSlice.reducer;
